import { defineStore } from 'pinia';
import api from '@/common/utils/api';
import ability from '@/common/ability';

export enum ActionsMap {
  GET = 'read',
  POST ='create',
  DELETE = 'delete',
  PATCH = 'update',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  PUT = 'update'
}

export interface MetaInfo {
  methods: ActionsMap[],
  name: string,
  url: string
}

export interface Rule {
  subject: string,
  actions: string
}

export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    permissionsAreLoaded: false
  }),
  actions: {
    async fetchAuthMeta() {
      const res: FetchResponse<Record<string, MetaInfo>> = await api.get('/api/v2/meta');
      const rules: Rule[] = [];

      Object.values(res.data)
        .forEach(resource => {
          const abilities: string[] = [];
          resource.methods.forEach(method => {
            if (ActionsMap[method]) {
              rules.push({
                subject: resource.name,
                actions: ActionsMap[method]
              });
              abilities.push(ActionsMap[method]);
            }
          });

          if (['delete', 'update'].every(x => abilities.includes(x))) {
            rules.push({
              subject: resource.name,
              actions: 'change'
            });
          }
        });
      ability.update(rules);
      this.permissionsAreLoaded = true;
      return rules;
    }
  }
});

export default usePermissionsStore;
